<template>
  <div
    :class="[ value==='' && required ? 'active' : 'unactive']"
    class="select-register">
    <select
      style="direction: rtl"
      class="select-reg"
      :value="value"
      @input="$emit('input', $event.target.value)" >
      <option class="opt-v" style="opacity: 0.6" disabled value=""> {{placeholder}}  </option>
      <option
        class="opt-v"
        :key="i*3"
        v-for="(option, i) in options">
        {{option}}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "SelectRegister",
  props: {
    value: {},
    required:{
      default: false,
    },
    direct:{
      default: false,
    },
    options: {},
    placeholder:{
      default: '',
    },
  }
}
</script>

<style scoped lang="scss">
:active, :hover, :focus {
   outline: 0;
   outline-offset: 0;
}

.select-register {
  width: 250px;
  position: relative;
  &.active{
    &:after{
      position: absolute;
      content: '*';
      color: #ff5c5c;
      right: 0;
    }
  }
  .select-reg {
    width: 100%;
    outline: none;
    border: none;
    border-radius: 0;
    background: transparent;
    border-bottom: 1px solid #FFFFFF;
    padding: 4px 4px;
    line-height: 20px;
    text-align: right;
    color: #FFFFFF;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none; /* Remove default arrow */
    background-image: url('../../assets/img/icons/select-arrow.svg'); /* Add custom arrow */
    background-position: left;
    background-repeat: no-repeat;
    font-size: 17px;
    padding-right: 15px;
    @media screen and (max-width: 600px) {
      font-size: 15px;
    }
    option {
      color: black;
      padding-left: 20px;
      span{
        color: red;
      }
    }
  }
}

/** rtl */
/**[dir="rtl"] .select-reg, :root:lang(ar) .select-reg, :root:lang(iw) .select-reg {*/
/*  background-position: left .7em top 50%, 0 0;*/
/*  padding: 4px 4px;*/
/*}*/

</style>